import $ from 'jquery/dist/jquery.min'

$(document).ready(function() {
  var $figure = $('.body-copy figure:has(iframe)')
  $figure.addClass('video-container');

  $figure.each(function() {
    var $iframe = $figure.find('iframe')
    var width = $iframe.css('width').replace('px', '');
    var height = $iframe.css('height').replace('px', '');
    var padding = (height/width) * 100 + '%';
    $(this).css('padding-bottom', padding);
    $iframe.css({width: '100%', height: '100%'})
  });

});



// WEBPACK FOOTER //
// ./web/src/app/javascripts/components/VideoStyle.jsx